module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAjklEQVR4Ae2WMRGAMBAEj4qSGgHIwAMuEIETTOABGQigpqSCTKpVcMVPfk/AzsCSoCZIkuTQKCu/Hq3qnIK6U5NTUPdqU+8RsEuzR8A+7Ro8AnZrMQkY8ZoExGsSEK9RQLw2AfEaBcTrFBBvQAGPKOhLJtN4HxpHRaDDjiDjXTgEGfbSJ8hwP14E2S5JkhREJjLSSX56vgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_play_arrow_black_24dp.png
// module id = 127
// module chunks = 0